(() => {
  'use strict';

  const getTomorrowInSydney = () => {
    const parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(new Date());

    const values = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });

    const tomorrow = new Date(Date.UTC(values.year, values.month - 1, values.day + 1));

    const tomorrowParts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'UTC',
      weekday: 'short',
      day: 'numeric',
      month: 'numeric'
    }).formatToParts(tomorrow);
    const tomorrowValues = {};
    tomorrowParts.forEach((part) => {
      if (part.type !== 'literal') tomorrowValues[part.type] = part.value;
    });
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${tomorrowValues.weekday}, ${tomorrowValues.day} ${monthNames[Number(tomorrowValues.month) - 1]}`;
  };

  if (!customElements.get('nuve-product-status')) {
    customElements.define('nuve-product-status', class extends HTMLElement {
      connectedCallback() {
        const date = this.querySelector('[data-nuve-dispatch-date]');
        if (!date) return;

        try {
          date.textContent = getTomorrowInSydney();
        } catch (error) {
          date.textContent = 'tomorrow';
        }
      }
    });
  }

})();
